import { jsx as i, jsxs as l, Fragment as D } from "react/jsx-runtime";
import { Listbox as E, Field as M, ListboxButton as C, ListboxOptions as T, ListboxOption as k } from "@headlessui/react";
import { useState as b, useEffect as q, useMemo as H } from "react";
import { useTranslation as z } from "../../i18n.mjs";
import { ArrowButton as G } from "./components/arrow-button.mjs";
import { CloseButton as J } from "./components/close-button.mjs";
import { ListLoader as K } from "./components/list-loader.mjs";
import { ListOptionsWrapper as Q } from "./components/list-options-wrapper.mjs";
import { getPanelHeight as U } from "./utils/get-panel-height.mjs";
import { getSelectedData as X } from "./utils/get-selected-data.mjs";
import { renderOption as Y } from "./utils/render-list-option.mjs";
import { twMerge as t } from "tailwind-merge";
import { getEmptyValue as Z } from "./constants/index.mjs";
function Ne({
  data: e,
  staticData: m,
  onChange: a,
  value: c,
  isPreFetching: N,
  placeholder: w,
  required: $,
  description: P,
  className: x,
  closeButtonClassName: L,
  arrowButtonClassName: B,
  fieldClassName: y,
  disabled: O,
  withoutCloseIcon: V,
  onOpen: u,
  onClose: ee,
  dataTest: te,
  wrapperProps: oe,
  loaderClassName: W,
  loaderWrapperClassName: v,
  captionClassName: F,
  inputRef: re,
  optionsClassName: I,
  ...o
}) {
  const { t: f } = z(), [p, R] = b(!1);
  q(() => {
    p && u && (u(), R(!1));
  }, [p]);
  const n = X(c, e ?? m) ?? null, d = c !== void 0, s = O || N || d && (!e && !m), h = d && !V && !s, g = H(() => {
    if (e)
      return e.length > 0 ? e : [Z(f)];
  }, [e]), [S, _] = b(null), j = U(S, e);
  return /* @__PURE__ */ i(
    E,
    {
      value: n,
      onChange: (r) => {
        r !== null && a(r == null ? void 0 : r.id);
      },
      disabled: s,
      children: ({ open: r }) => /* @__PURE__ */ l(D, { children: [
        /* @__PURE__ */ l(M, { className: t("relative flex w-fit flex-col gap-1", y), children: [
          /* @__PURE__ */ l(
            C,
            {
              className: t(
                "inline-grid w-fit",
                "pr-6",
                h && "pr-10",
                "focus-ring rounded-md outline-hidden",
                x
              ),
              children: [
                /* @__PURE__ */ i(
                  "span",
                  {
                    className: t(
                      "text-start truncate underline decoration-dashed",
                      F
                    ),
                    children: (n == null ? void 0 : n.caption) ?? w ?? f("public_pages_purchase.form_select.select")
                  }
                ),
                /* @__PURE__ */ i(
                  G,
                  {
                    As: C,
                    isDisabled: s,
                    arrowButtonClassName: t(
                      "absolute bottom-0 right-0",
                      "h-6 w-4",
                      B
                    ),
                    open: r
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ i(
            J,
            {
              isDisabled: s,
              closeButtonClassName: t(
                "absolute bottom-0 right-5 ",
                "h-6 w-4",
                L
              ),
              onClick: () => a(void 0)
            }
          )
        ] }),
        /* @__PURE__ */ i(
          Q,
          {
            ref: _,
            style: { height: j },
            as: T,
            optionsClassName: t("h-fit w-fit outline-hidden", I),
            children: g ? g.map(
              (A) => Y({
                item: A,
                as: k,
                optionClassName: o == null ? void 0 : o.optionClassName,
                optionIconWrapperClassName: o == null ? void 0 : o.optionIconWrapperClassName
              })
            ) : /* @__PURE__ */ i(
              K,
              {
                loaderWrapperClassName: t("p-2", v),
                loaderClassName: W
              }
            )
          }
        )
      ] })
    }
  );
}
export {
  Ne as FormSelectInline
};
